import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { apiFetch } from '../lib/api';
import { setMeta } from '../lib/seo';
import ItineraryView from '../components/ItineraryView';
import Footer from '../components/Footer';
import NotFound from './NotFound';

const BACKEND = process.env.REACT_APP_BACKEND_URL || '';

export default function PublicTrip() {
  const { publicId } = useParams();
  const [trip, setTrip] = useState(null);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await apiFetch(`/api/public/trips/${publicId}`);
        setTrip(data);
      } catch (e) {
        setErr(e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [publicId]);

  useEffect(() => {
    if (!trip) return;
    const ogImage = `${BACKEND}/api/og/trip/${publicId}.png`;
    setMeta({
      title: `${trip.title} — Shared on Culinera`,
      description: `A ${trip.tripDuration} Alberta culinary journey starting in ${trip.startingLocation}. Plan your own free at culinera.ca.`,
      canonical: `https://culinera.ca/trip/${publicId}`,
      image: ogImage,
      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'TravelAction',
        name: trip.title,
        description: `Alberta culinary trip: ${trip.restaurants?.length || 0} restaurants`,
        fromLocation: { '@type': 'Place', name: trip.startingLocation, address: { '@type': 'PostalAddress', addressRegion: 'AB', addressCountry: 'CA' } },
      },
    });
  }, [trip, publicId]);

  if (loading) return <div className="min-h-screen flex items-center justify-center text-gray-500">Loading shared trip…</div>;
  if (err) {
    return <NotFound />;
  }

  // Adapt saved trip shape to ItineraryView shape
  const restaurants = trip.restaurants || [];
  const days = trip.days && trip.days.length
    ? trip.days
    : [{ day: 1, meals: restaurants.slice(0, 3).map((r, i) => ({ slot: ['Breakfast', 'Lunch', 'Dinner'][i] || 'Meal', restaurant: r })) }];

  return (
    <>
      <ItineraryView
        itinerary={{
          title: trip.title,
          duration: parseInt(trip.tripDuration) || 3,
          restaurants,
          foodTrucks: [],
          days,
          summary: {
            location: trip.startingLocation,
            duration: trip.tripDuration,
            groupSize: trip.groupSize,
            budget: trip.budgetRange,
            cuisines: trip.cuisineTypes || [],
          },
        }}
        onBack={() => { window.location.href = '/'; }}
        user={null}
        readOnly
      />
      <Footer />
    </>
  );
}
